export default "__VITE_ASSET__148427ff__"